import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import HizmetDetay from '../../components/HizmetDetay';
import klimaResmi from '../../assets/klima-teknik-servis-resim.webp';
import AOS from 'aos';
import 'aos/dist/aos.css';

function KlimaServisi() {
  // --- AOS VE DİNAMİK BAŞLIK AYARI ---
  useEffect(() => {
    // Sekme ismini zorla güncelliyoruz
    document.title = "Ankara Klima Teknik Servis | Bakım, Tamir & Gaz Dolumu";
    
    window.scrollTo(0, 0);
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  // --- GOOGLE İÇİN ÖZEL KLİMA SERVİS ŞEMASI (JSON-LD) ---
  const climateSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Klima Teknik Servis ve Bakım",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Ankara Merkez Teknik",
      "telephone": "+903125810881",
      "areaServed": "Ankara"
    },
    "description": "Ankara genelinde 7/24 profesyonel klima tamiri, periyodik bakım, R410A ve R32 gaz dolumu, söküm ve montaj hizmetleri. Tüm markalarda garantili servis.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Klima Hizmetleri",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Klima Gaz Dolumu" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Klima Kart Tamiri" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Klima Montaj ve Söküm" } }
      ]
    }
  };

  return (
    <>
      <Helmet>
        <title>Ankara Klima Teknik Servis | Bakım, Tamir & Gaz Dolumu</title>
        <meta name="description" content="Ankara'da Arçelik, Samsung, LG, Daikin ve Mitsubishi klimalarınız için 7/24 garantili gaz dolumu, tamir ve bakım. Hemen arayın, hızlı servis alın!" />
        {/* Google botları için teknik veri kartı */}
        <script type="application/ld+json">
          {JSON.stringify(climateSchema)}
        </script>
      </Helmet>

      <div data-aos="fade-up">
        <HizmetDetay 
          icon="🌬️"
          baslik="Ankara Klima Teknik Servis"
          stat1="Uzman İklimlendirme"
          stat2="Aynı Gün"
          resim={klimaResmi}
          aciklama="Klimanız soğutmuyor, su akıtıyor veya kötü koku mu yayıyor? Yazın sıcağında, kışın soğuğunda mağdur olmamanız için Ankara genelinde klima bakım, onarım ve gaz dolum işlemlerinizi yerinde çözüyoruz."
          seoMetni={(
            <>
              {/* SEO KART 1: GENEL HİZMET */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="100">
                <h4>Ankara Geneli Profesyonel İklimlendirme</h4>
                <p>
                  Yaz aylarının kavurucu sıcaklarında ve kışın zorlu şartlarında <strong>ankara klima</strong> sistemleriniz için kesintisiz <strong>klima teknik servis</strong> sağlıyoruz. Tüm başkentte <strong>ankara klima servisi</strong> ağımızla; <strong>Çankaya klima teknik servis</strong>, <strong>Yenimahalle klima servisi</strong>, <strong>Keçiören klima tamircisi</strong> ve <strong>Altındağ klima yetkili</strong> noktalarımızda anında müdahale ediyoruz.
                </p>
              </div>

              {/* SEO KART 2: YERLİ MARKALAR */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="200">
                <h4>Yerli Üretim Klimalarda Tam Donanım</h4>
                <p>
                  Türkiye'nin en çok kullanılan iklimlendirme cihazlarında <strong>arçelik klima teknik servis</strong> ve <strong>beko klima teknik servis</strong> standartlarında profesyonel bakım sunuyoruz. <strong>vestel klima teknik servis</strong> ihtiyaçlarınızda motor tamiri ve kart onarımları garantili yapılır. <strong>Mamak arçelik klima servisi</strong> ve <strong>Pursaklar beko klima tamircisi</strong> bölgelerinde aktifiz.
                </p>
              </div>

              {/* SEO KART 3: TEKNOLOJİ DEVLERİ */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="300">
                <h4>Japon ve Güney Kore İklimlendirme Teknolojileri</h4>
                <p>
                  Inverter teknolojisinde lider markaların hassas onarımlarını üstleniyoruz. <strong>samsung sincan klima servisi</strong> arayışlarınıza profesyonel yanıt veriyor, <strong>LG ankara klima teknik servis</strong> süreçlerini yönetiyoruz. <strong>Mitsubishi ankara klima servisi</strong>, <strong>Daikin çankaya klima yetkili</strong> ve <strong>Midea eryaman klima servisi</strong> ağımızla hizmetinizdeyiz.
                </p>
              </div>

              {/* SEO KART 4: MONTAJ VE BAKIM */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="400">
                <h4>Kapsamlı Marka Ağı ve Klima Bakım Süreçleri</h4>
                <p>
                  Sadece onarım değil, söküm ve montaj hizmetlerimiz de mevcuttur. <strong>Bosch ankara klima servisi</strong>, <strong>Demirdöküm ankara klima servisi</strong> ve <strong>Baymak sincan klima tamircisi</strong> hizmetlerimizle 7/24 yanınızdayız. Tüm markalarda R410A ve R32 gaz dolumu ile drenaj pompası tamiri 1 yıl garantilidir.
                </p>
              </div>
            </>
          )}
        />
      </div>
    </>
  );
}

export default KlimaServisi;